export default "__VITE_ASSET__Cxyl8aC0__"